import { Icon, Tooltip } from '@nike/eds'
import { Rebooking, TrackTraceException } from '../../generated/graphql'
import { capitalize } from '../../common/utils/formatter'

export interface ttExceptionsIndicatorProps {
  ttExceptions: Array<TrackTraceException>
}

export function TTExceptionsIndicator({ ttExceptions }: ttExceptionsIndicatorProps) {
  return (
    <>
      {ttExceptions?.length ? (
        <Tooltip
          bodySlot={ttExceptions.reduce(
            (currentValue, e) =>
              `${e.code}: ${e.description}${currentValue ? '; ' : ''}${currentValue}`,
            ''
          )}
        >
          <Icon name="AlertCircle" size="s" color="var(--eds-color-brand-red)" />
        </Tooltip>
      ) : (
        ''
      )}
    </>
  )
}

export interface RebookingIndicatorProps {
  rebooking: Rebooking
}

export function RebookingIndicator({ rebooking }: RebookingIndicatorProps) {
  return (
    <>
      {rebooking ? (
        <Tooltip bodySlot={capitalize(rebooking.rebookingType || '')}>
          <Icon name="Transfers" size="s" />
        </Tooltip>
      ) : (
        ''
      )}
    </>
  )
}
